import { Component, Input } from '@angular/core';
import { AnswerInfo } from 'src/app/models/models';
import { FormOptions } from 'src/app/classes/FormOptions';
import { Form, Response } from 'src/app/models/RestModels';

/**
 * Muestra una respuesta de formulario (question/answer) en modo lectura.
 * Se usa en view-quote y view-quote/view-order para visualizar los
 * formularios capturados en la cabecera y en los items.
 */
@Component({
	selector: 'app-form-response-viewer',
	templateUrl: './form-response-viewer.component.html',
	styleUrls: ['./form-response-viewer.component.css']
})
export class FormResponseViewerComponent
{
	@Input() response: Response | null | undefined = null;
	@Input() form: Form | null | undefined = null;
	@Input() answers: AnswerInfo[] | undefined = [];

	get sorted_answers(): AnswerInfo[]
	{
		return (this.answers || []).slice().sort((a,b)=> b.question.priority - a.question.priority);
	}

	getAnswerValue(ai: AnswerInfo): string
	{
		//Los textos informativos (label) no llevan respuesta.
		if( FormOptions.isLabel(ai.question) )
			return '';

		//Los checkbox guardan un arreglo JSON con las opciones marcadas.
		if( FormOptions.isCheckbox(ai.question) )
		{
			let joined = FormOptions.parseCheckboxAnswer(ai.answer?.answer_text).join(', ');

			if( joined )
				return joined;
		}
		else if( ai.answer?.answer_text )
		{
			return ai.answer.answer_text;
		}

		//answer_number en 0 es el default de GetEmpty y no cuenta como respuesta.
		if( ai.answer?.answer_number != null && ai.answer.answer_number !== 0 )
			return String(ai.answer.answer_number);

		return '—';
	}
}
